"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var LoggerLevel;
(function (LoggerLevel) {
    LoggerLevel[LoggerLevel["NONE"] = 0] = "NONE";
    LoggerLevel[LoggerLevel["ERROR"] = 1] = "ERROR";
    LoggerLevel[LoggerLevel["INFO"] = 2] = "INFO";
    LoggerLevel[LoggerLevel["DEBUG"] = 3] = "DEBUG";
})(LoggerLevel = exports.LoggerLevel || (exports.LoggerLevel = {}));
var serviceUrl = "";
var store = true;
var logLevel = LoggerLevel.ERROR;
var intDone = false;
function LoggerLog(message) {
    var date = new Date(Date.now());
    var utc = date.toUTCString();
    console.log(utc + " - LOG - " + message);
}
exports.LoggerLog = LoggerLog;
function LoggerError(message) {
    var date = new Date(Date.now());
    var utc = date.toUTCString();
    console.error(utc + " - ERR - " + message);
}
exports.LoggerError = LoggerError;
function LoggerDbg(message) {
    var date = new Date(Date.now());
    var utc = date.toUTCString();
    console.debug(utc + " - DBG - " + message);
}
exports.LoggerDbg = LoggerDbg;
function LoggerInfo(message) {
    var date = new Date(Date.now());
    var utc = date.toUTCString();
    console.info(utc + " - INF - " + message);
}
exports.LoggerInfo = LoggerInfo;
// export var loggerDbROpenReuest: IDBOpenDBRequest = undefined;
// export var loggerDatabase: IDBDatabase = undefined;
// (<any>window).indexedDB = <any>(<any>window).indexedDB || (<any>window).mozIndexedDB || (<any>window).webkitIndexedDB || (<any>window).msIndexedDB;
// (<any>window).IDBTransaction = (<any>window).IDBTransaction || (<any>window).webkitIDBTransaction || (<any>window).msIDBTransaction || { READ_WRITE: "readwrite" }; // This line should only be needed if it is needed to support the object's constants for older browsers
// (<any>window).IDBKeyRange = (<any>window).IDBKeyRange || (<any>window).webkitIDBKeyRange || (<any>window).msIDBKeyRange;
function LoggerInit(level, useStore) {
    if (level === void 0) { level = LoggerLevel.DEBUG; }
    if (useStore === void 0) { useStore = false; }
    logLevel = level;
    if (!intDone) {
        // if (useStore) {
        //   if (!window.indexedDB) {
        //     old_console_log("Your browser doesn't support a stable version of IndexedDB. Such and such feature will not be available.");
        //   } else {
        //     loggerDbROpenReuest = indexedDB.open("logerr");
        //     loggerDbROpenReuest.onupgradeneeded = (event: IDBVersionChangeEvent) => {
        //       if (!loggerDbROpenReuest.result.objectStoreNames.contains("log")) {
        //         loggerDbROpenReuest.result.createObjectStore("log", {
        //           autoIncrement: true,
        //           keyPath: "id"
        //         });
        //       }
        //       if (!loggerDbROpenReuest.result.objectStoreNames.contains("settings")) {
        //         loggerDbROpenReuest.result.createObjectStore("settings", {
        //           keyPath: "key"
        //         });
        //       }
        //       loggerDbROpenReuest.onerror = (event: Event) => {
        //         old_console_log("Logger dababase error !");
        //       };
        //       loggerDbROpenReuest.onsuccess = (event: Event) => {
        //         loggerDatabase = loggerDbROpenReuest.result;
        //       };
        //     };
        //   }
        // }
        intDone = true;
    }
}
exports.LoggerInit = LoggerInit;
// function saveToDB(message: string) {
//   if (loggerDatabase) {
//     let tran = loggerDatabase.transaction("log", "readwrite");
//     let store = tran.objectStore("log");
//     let dt = new Date();
//     let utc = dt.toUTCString();
//     let item = {
//       date: dt,
//       utc: utc,
//       msg: message
//     };
//     store.add(item);
//   }
// }
// export function setLoggerUser(userName: string) {}
// export function setLoggerClear(userName: string) {}
function LoggerClass(constructor) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        return class_1;
    }(constructor));
}
exports.LoggerClass = LoggerClass;
function LoggerMethod(level) {
    return function (target, propertyKey, descriptor) {
        LoggerInit();
        level = level ? level : logLevel;
        if (target && target["constructor"] && target["constructor"]["name"]) {
            descriptor["loggerClassName"] = target["constructor"]["name"];
        }
        else {
            descriptor["loggerClassName"] = "";
        }
        descriptor["loggerPropertyKey"] = descriptor["loggerClassName"] + ":" + propertyKey;
        if (descriptor["value"] && typeof descriptor["value"] == "function") {
            var mth_1 = descriptor["value"];
            descriptor["value"] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                try {
                    if (level >= LoggerLevel.DEBUG) {
                        LoggerLog("Call    : " + descriptor["loggerPropertyKey"] + " " + (args != undefined && args.length > 0 ? "args: " + args : ""));
                    }
                    var res = mth_1.call.apply(mth_1, [this].concat(args));
                    if (level >= LoggerLevel.DEBUG) {
                        LoggerLog("Executed: " + descriptor["loggerPropertyKey"] + " " + (res != undefined ? "res: " + res : ""));
                    }
                    return res;
                }
                catch (error) {
                    if (level != LoggerLevel.NONE) {
                        LoggerError("Error   : " + descriptor["loggerPropertyKey"] + " error: " + error + "\n " + prepareCallStack(new Error().stack));
                    }
                }
            };
        }
    };
}
exports.LoggerMethod = LoggerMethod;
function prepareCallStack(callStack) {
    var array = callStack.split("\n");
    if (array.length > 2)
        array.splice(1, 1);
    return array.join("\n");
}
